<template>
  <create-schedule class="content md"></create-schedule>
</template>

<script>
    import CreateSchedule from "./create/CreateSchedule";

    export default {
        name: "ActivityGroup",
        components: {
            CreateSchedule
        },
    }
</script>

<style scoped lang="less">
</style>
